module.exports = __webpack_public_path__ + "img/sv26.da0b7408.svg";